import styled, { css } from "styled-components";
import { ScrollToTopOnMount, parseCSS } from "scripts/FunctionsBundle";
import {
  Form,
  useLoaderData,
  useNavigate,
  useNavigation,
  useParams,
} from "react-router-dom";
import * as _T from "@utils/ClassTypes";
import SacramentosForms from "@components/SacramentosForms";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { GS } from "App";
import SacramentosPrint from "./SacramentosPrint";

// ################################ INTERFACES & PROPS ################################
type _Base = import("@utils/ClassTypes")._Base;
// SacramentosAction => Rename all instances to use
type SacramentosActionProps = {} & _Base;

const actions = {
  new: "Crear ",
  edit: "Editar ",
  print: "Imprimir ",
  delete: "Eliminar ",
};

// ################################ RENDERING COMPONENT ################################
const _SacramentosAction = (props: SacramentosActionProps) => {
  type a = _T.Bautizo | _T.Comunion | _T.Confirmacion | _T.Matrimonio;

  const { type, id, action } = useParams();
  const { el } = useLoaderData() as { el: a };
  const navigate = useNavigate();

  // ------------------------------------------------------------------------------------ LS STATE
  const [LS] = useState(el);
  const nav = useNavigation();

  // ------------------------------------------------------------------------------------ CLEAN UP CACHE
  useEffect(() => {
    return () => {
      GS.cache = {};
    };
  }, []);

  // ------------------------------------------------------------------------------------ RETURN
  return (
    <div className={props.className + " screen"}>
      <Helmet>
        <title>
          {actions[action || "new"] + type + ": <" + id + ">"} | RSA
        </title>
      </Helmet>

      <ScrollToTopOnMount />

      <h1>{actions[action || "new"] + type}</h1>
      <h2>{id}</h2>

      {/* ------------------------------------------------------------------------------------ CANCELAR */}
      <button
        className="return-button big"
        onClick={() => {
          GS.cache = {};
          navigate(-1);
        }}
      >
        {"<-- Regresar"}
      </button>

      {action === "print" ? (
        <SacramentosPrint _type={type || "bautizos"} _el={el} />
      ) : (
        <Form
          method={"post"}
          className={nav.state === "submitting" ? "disabled loading" : ""}
          onSubmit={() => {
            GS.cache = { el: LS };
          }}
        >
          {/* ------------------------------------------------------------------------------------ FORM CONTENTS */}
          <SacramentosForms
            _store={LS}
            _sacramento={type as "bautizos"}
            _disabled={action === "delete"}
          />

          {/* ------------------------------------------------------------------------------------ GUARDAR CAMBIOS */}
          <button
            className={
              "submit-button big " +
              (action === "delete" ? "danger" : "primary")
            }
            disabled={nav.state === "submitting"}
          >
            {action === "new"
              ? "Guardar nuevo"
              : action === "edit"
              ? "Guardar cambios"
              : action === "delete"
              ? "Eliminar registro"
              : "Acción desconocida"}
          </button>
        </Form>
      )}
    </div>
  );
};

// ################################ STYLES ################################
const SacramentosAction = styled(_SacramentosAction).attrs(
  (props: SacramentosActionProps): SacramentosActionProps => {
    return { ...props };
  }
)`
  ${(props) => css`
    .return-button,
    .submit-button {
      display: block;
      min-width: 10rem;
      margin: 0.5rem 2.5rem;
    }

    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################
export default SacramentosAction;
